import { useParams } from 'react-router-dom'

import CompanyProfileContainer from '../containers/companies/Profile'

const CompanyPage = () => {
  const { id } = useParams<{ id: string }>()
  if(!id) {
    return <div>Invalid company id</div>
  }
  return <CompanyProfileContainer id={parseInt(id)} />
}

export default CompanyPage
